// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as PropSpread$LiveRoom from "../../components/PropSpread.bs.js";
import * as CommonStyles$LiveRoom from "../../styles/CommonStyles.bs.js";
import * as SterlingModal$LiveRoom from "../../bindings/SterlingModal.bs.js";
import * as Form from "@sothebys/sterling/form";
import * as SterlingTokens$LiveRoom from "../../bindings/SterlingTokens.bs.js";
import * as ConditionOfSale$LiveRoom from "./ConditionOfSale.bs.js";

var wrapper = Curry._1(Css.style, {
      hd: Css.display(Css.flexBox),
      tl: {
        hd: Css.marginTop(Css.px(8)),
        tl: /* [] */0
      }
    });

var chekboxContainer = Curry._1(Css.style, {
      hd: Css.marginTop(Css.px(3)),
      tl: {
        hd: Css.height(Css.px(20)),
        tl: {
          hd: Css.width(Css.px(20)),
          tl: /* [] */0
        }
      }
    });

function getDisclaimerTextByAuctionLocation(auctionLocation, t) {
  var match = Belt_Option.getWithDefault(auctionLocation, "").toLowerCase();
  if (match === "new york") {
    return [
            " " + Curry._1(t, "ConfirmCondition_byCheckingThisBox_NY"),
            " " + Curry._1(t, "ConfirmCondition_bidsPlacedInOnlineOnlySales_NY")
          ];
  } else {
    return [
            Curry._1(t, "ConfirmCondition_byCheckingThisBox_UK_Europe_HK"),
            " " + Curry._1(t, "ConfirmCondition_bidsPlacedInOnlineOnlySales_UK_Europe_HK")
          ];
  }
}

function ConfirmCondition$DisclaimerText(props) {
  return React.createElement("p", {
              className: Curry._1(Css.style, {
                    hd: Css.display(Css.contents),
                    tl: {
                      hd: Css.fontWeight(props.bold ? ({
                                NAME: "num",
                                VAL: 600
                              }) : ({
                                NAME: "num",
                                VAL: 300
                              })),
                      tl: /* [] */0
                    }
                  })
            }, props.text);
}

var DisclaimerText = {
  make: ConfirmCondition$DisclaimerText
};

function ConfirmCondition$ConditionsOfSaleLink(props) {
  var conditionOfSaleText = props.conditionOfSaleText;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  var match$1 = React.useState(function () {
        return /* NoModal */0;
      });
  var setModalToShow = match$1[1];
  var modalToShow = match$1[0];
  return React.createElement(React.Fragment, undefined, React.createElement(PropSpread$LiveRoom.make, {
                  data: {
                    hd: {
                      TAG: /* TestId */1,
                      _0: "conditionsOfBusinessLink"
                    },
                    tl: /* [] */0
                  },
                  children: React.createElement("span", {
                        className: Curry._1(Css.style, {
                              hd: Css.hover({
                                    hd: Css.cursor("pointer"),
                                    tl: /* [] */0
                                  }),
                              tl: {
                                hd: Css.textDecoration(Css.underline),
                                tl: {
                                  hd: Css.fontWeight({
                                        NAME: "num",
                                        VAL: 600
                                      }),
                                  tl: /* [] */0
                                }
                              }
                            }),
                        onClick: (function (param) {
                            Curry._1(setModalToShow, (function (param) {
                                    return /* ConditionsOfSale */{
                                            _0: conditionOfSaleText
                                          };
                                  }));
                          })
                      }, Curry._1(t, "Common_conditionsOfBusiness"))
                }), modalToShow ? React.createElement(SterlingModal$LiveRoom.Modal.make, {
                    children: React.createElement(ConditionOfSale$LiveRoom.make, {
                          conditionOfSaleText: modalToShow._0
                        }),
                    onClose: (function (param) {
                        Curry._1(setModalToShow, (function (param) {
                                return /* NoModal */0;
                              }));
                      }),
                    isOpen: true,
                    size: "large",
                    headerTitle: Curry._1(t, "Common_conditionsOfBusiness")
                  }) : null);
}

var ConditionsOfSaleLink = {
  make: ConfirmCondition$ConditionsOfSaleLink
};

function ConfirmCondition(props) {
  var onCheckboxChanged = props.onCheckboxChanged;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  var match$1 = getDisclaimerTextByAuctionLocation(props.auctionLocation, t);
  return React.createElement("div", {
              className: wrapper
            }, React.createElement(PropSpread$LiveRoom.make, {
                  data: {
                    hd: {
                      TAG: /* TestId */1,
                      _0: "checkBoxConditionsOfBusiness"
                    },
                    tl: /* [] */0
                  },
                  children: React.createElement("div", {
                        className: chekboxContainer
                      }, React.createElement(Form.Checkbox, {
                            name: "ConfirmCondition-LiveRoom",
                            className: Curry._1(Css.style, {
                                  hd: Css.focusWithin(CommonStyles$LiveRoom.buttonFocus),
                                  tl: /* [] */0
                                }),
                            checked: props.checked,
                            onChange: (function ($$event) {
                                Curry._1(onCheckboxChanged, $$event.target.checked);
                              })
                          }))
                }), React.createElement(PropSpread$LiveRoom.make, {
                  data: {
                    hd: {
                      TAG: /* TestId */1,
                      _0: "textConfirmConditionOfSale"
                    },
                    tl: /* [] */0
                  },
                  children: React.createElement("div", {
                        className: Curry._1(Css.style, {
                              hd: Css.marginLeft(Css.px(16)),
                              tl: {
                                hd: Css.fontWeight({
                                      NAME: "num",
                                      VAL: 400
                                    }),
                                tl: {
                                  hd: Css.fontSize(Css.px(16)),
                                  tl: {
                                    hd: Css.lineHeight(Css.px(24)),
                                    tl: {
                                      hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey90_nohashtag)),
                                      tl: {
                                        hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                                              hd: Css.fontSize(Css.px(14)),
                                              tl: {
                                                hd: Css.lineHeight(Css.px(18)),
                                                tl: /* [] */0
                                              }
                                            }),
                                        tl: /* [] */0
                                      }
                                    }
                                  }
                                }
                              }
                            })
                      }, React.createElement(ConfirmCondition$DisclaimerText, {
                            text: Curry._1(t, "ConfirmCondition_byCheckingThisBoxYouConfirm") + " ",
                            bold: false
                          }), React.createElement(ConfirmCondition$ConditionsOfSaleLink, {
                            conditionOfSaleText: props.conditionOfSaleText
                          }), React.createElement(ConfirmCondition$DisclaimerText, {
                            text: match$1[0],
                            bold: false
                          }), React.createElement(ConfirmCondition$DisclaimerText, {
                            text: match$1[1],
                            bold: false
                          }))
                }));
}

var make = ConfirmCondition;

export {
  wrapper ,
  chekboxContainer ,
  getDisclaimerTextByAuctionLocation ,
  DisclaimerText ,
  ConditionsOfSaleLink ,
  make ,
}
/* wrapper Not a pure module */
